/*
 * Project: BookingEngine
 * Module: components/booking/rooms/RoomRateBoard.js
 */
import React from 'react';
import PropTypes from 'prop-types';

import CheckFillIcon from '../../icons/CheckFillIcon';

import SeeDetails from '../../ds/molecules/btn/seeDetails';

import { getLangValue } from '../../../utils/Generic';
import { MULTIPLE_ROOMS } from '../../../constants';

class RoomRateBoard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDetails: false,
    };
    this.toggleDetails = this.toggleDetails.bind(this);
  }

  getHotelBoard(ownRoom) {
    try {
      const rooms = this.props.hotel.rooms[MULTIPLE_ROOMS.FIRST];
      const roomData = rooms.find((room) => room.code === ownRoom.room.code);
      const rateData = roomData.rates.find((rate) => rate.code === ownRoom.rate.code);
      return rateData.boards.find((board) => board.code === ownRoom.board.code);
    } catch (e) {
      return null;
    }
  }

  getHotelBoardText(cartRoom) {
    // We want the hotel board to be able to get the full description
    const board = this.getHotelBoard(cartRoom);
    if (!board) {
      return null;
    }
    const baseText = getLangValue(board, this.props.lang, 'boardDescription');
    const lines = baseText.split(/[\r\n]+/).filter((line) => !!line) || [];
    if (lines.length === 0) {
      return null;
    }
    const isHtml = lines.length <= 5;
    return {
      text: isHtml ? lines : baseText,
      html: isHtml,
    };
  }

  toggleDetails() {
    this.setState({ showDetails: !this.state.showDetails });
  }

  renderRateConditions(rate) {
    const { showDetails } = this.state;
    return (
      <div className="cartroom__rate mt-3">
        <button className="btn-clear w-100" onClick={this.toggleDetails}>
        <h3 className="cartroom__rate-name mb-0">
          {getLangValue(rate, this.props.lang, 'name')}: <br></br>
        </h3>
        <div className="cartroom__rate-name small">
           {rate.can_cancel && <CheckFillIcon />}
           {rate.can_cancel ? this.context.t('Free cancellation') : this.context.t('Cancellation conditions')}
            <SeeDetails className="mx-2" />
          </div>
        </button>
        { showDetails && <p className="small">
            {getLangValue(rate, this.props.lang, 'cancellation_txt')}
          </p>
        }
      </div>
    );
  }

  /* eslint-disable react/no-danger */
  renderBoardInfo(cartRoom) {
    const boardText = this.getHotelBoardText(cartRoom);
    if (!boardText) {
      return null;
    }
    if (!boardText.html) {
      return (
        <span dangerouslySetInnerHTML={{ __html: boardText.text }} />
      );
    }
    return (
      <ul className="board-item__highlights">
        {boardText.text.map((boardLine, index) => (
          <li key={`boardLine_${index}`} className="highlights-item">
            <CheckFillIcon />
            <span dangerouslySetInnerHTML={{ __html: boardLine }} />
          </li>
        ))}
      </ul>
    );
  }
  /* eslint-enable react/no-danger */

  renderNewMemberDiscountPercentage() {
    if (this.props.new_member_discount_percentage_activated === true && this.props.new_member === true) {
      return (
        <div className="cartroom__rateboard">
          <div className="cartroom__board">
            <h3 className="cartroom__board-name font-bold">
              {this.context.t('CONGRATULATIONS!')}
            </h3>
            <h3 className="cartroom__board-name">
              {this.context.t('For being a')}&nbsp;<span className="flex flex-no-wrap font-bold">{this.props.loyaltyName}&nbsp;{this.context.t('NEW MEMBER')}</span>,&nbsp;{this.context.t('you can have now the')}&nbsp;<span className="flex flex-no-wrap font-bold">{this.context.t('BEST RATE AVAILABLE!')}</span>
            </h3>
          </div>
        </div>
      );
    }
    return null;
  }

  render() {
    const { room, lang } = this.props;
    return (
      <div>
        {this.renderNewMemberDiscountPercentage()}
        <div className="cartroom__rateboard">
          <div className="cartroom__board">
            <h3 className="cartroom__board-name">
              {getLangValue(room.board, lang, 'name')}
            </h3>
            {this.renderBoardInfo(room)}
          </div>
          {this.renderRateConditions(room.rate)}
        </div>
      </div>
    );
  }
}

RoomRateBoard.propTypes = {
  hotel: PropTypes.object.isRequired,
  room: PropTypes.object.isRequired,
  lang: PropTypes.string.isRequired,
  new_member: PropTypes.bool.isRequired,
  new_member_discount_percentage_activated: PropTypes.bool.isRequired,
  loyaltyName: PropTypes.string.isRequired,
};

RoomRateBoard.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default RoomRateBoard;
